/**
 * RPDM W1-D · Workspace feature-flag gate hook.
 *
 * The gate rule (mirrored on backend `feature_flags.snapshot`):
 *   - `rpdm_workspace_enabled` is the MASTER kill-switch.
 *   - A surface is considered ON iff:
 *         master && surface_flag
 *   - `/delivery` is gated by the master flag ONLY (passthrough).
 *
 * All flags default to `false` (fail-closed) when absent. With every
 * flag off, callers must render the pre-W1-D behaviour byte-identically.
 */
import { useAuth } from "@/contexts/AuthContext";

export const RPDM_FLAG_NAMES = Object.freeze({
    MASTER: "rpdm_workspace_enabled",
    SUMMARY_LANDING: "rpdm_workspace_summary_landing_enabled",
    TEAM: "rpdm_workspace_team_enabled",
    SETTINGS: "rpdm_workspace_settings_enabled",
});

export function useRpdmWorkspaceGate() {
    const { isFlagEnabled } = useAuth();

    const master = isFlagEnabled(RPDM_FLAG_NAMES.MASTER);

    return {
        master,
        summaryLanding: master && isFlagEnabled(RPDM_FLAG_NAMES.SUMMARY_LANDING),
        team: master && isFlagEnabled(RPDM_FLAG_NAMES.TEAM),
        settings: master && isFlagEnabled(RPDM_FLAG_NAMES.SETTINGS),
        // Delivery route is a passthrough gated ONLY by the master flag.
        delivery: master,
    };
}
